import React, { useState, useEffect, useMemo } from 'react';
import { useNotify, useDataProvider, usePermissions } from 'react-admin';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import { PERMISSIONS } from '../../constants';
import { getChainId, getEmployeeType, getAttendantId } from '../../lib';
import useDashboardContext from '../../hooks/useDashboardContext';
import { DashboardWrapper, RotatedAxisTick } from '../../components';
import { EmployeeType } from '../../models';

const chartMargin = { top: 20, right: 30, left: 20, bottom: 10 };
const axisLine = { stroke: '#CCCCCC' };
const tooltipContentStyle = {
    backgroundColor: '#ffffff',
    border: '1px solid #cccccc',
    borderRadius: '5px',
    padding: '10px',
    fontSize: '14px',
    color: '#333333',
    boxShadow: '0 1px 4px rgba(0,0,0,0.3)',
};
const cursorStyle = { fill: '#f5f5f5' };
const barRadius = [5, 5, 0, 0];
const yAxisDomain = ['auto', 'auto'];

export const FillinsByHour = () => {
    const [fillinsData, setFillinsData] = useState(null);

    const { permissions } = usePermissions();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const { from, to, chain, origin, stationIds } = useDashboardContext();

    const chainId = permissions && permissions.includes(PERMISSIONS.ADMIN) ? chain : getChainId();

    useEffect(() => {
        const filter = { from, to, origin };
        if (stationIds && stationIds.length > 0) {
            filter.placeIds = stationIds;
        }
        if (getEmployeeType() === EmployeeType.attendant) {
            filter.attendantId = getAttendantId();
        }

        if (permissions && permissions.includes(PERMISSIONS.FILLINS_BY_HOUR)) {
            dataProvider.getList('dashboard/fillins-per-hour', {
                filter, chainId,
            })
                .then((response) => {
                    setFillinsData(response.data);
                })
                .catch((e) => {
                    notify('Erro ao carregar abastecimentos por hora.', 'warning', console.log(e));
                });
        }
    }, [permissions, from, to, chain, origin, stationIds]);

    const chartContent = useMemo(() => (
        <BarChart data={fillinsData || []} margin={chartMargin}>
            <CartesianGrid strokeDasharray="4 4" stroke="#E0E0E0" />
            <XAxis
                dataKey="hour"
                tick={<RotatedAxisTick fontSize={12} />}
                interval={0}
                height={40}
                tickLine={false}
                axisLine={axisLine}
            />
            <YAxis
                width={50}
                domain={yAxisDomain}
                type="number"
                tickLine={false}
                axisLine={axisLine}
            />
            <Tooltip
                isAnimationActive={true}
                contentStyle={tooltipContentStyle}
                cursor={cursorStyle}
            />
            <Bar
                dataKey="count"
                fill="#79CF62"
                barSize={40}
                radius={barRadius}
                name="Quantidade de Abastecimentos"
                isAnimationActive={true}
            />
        </BarChart>
    ), [fillinsData]);

    return (
        <DashboardWrapper
            permission={PERMISSIONS.FILLINS_BY_HOUR}
            title="Abastecimentos Por Hora"
            aspectRatio={6.0 / 2.5}
            count={fillinsData?.length || 0}
            loading={fillinsData === null}
            content={chartContent}
        />
    );
};
